import { FormControl, InputLabel, Select as MuiSelect } from '@mui/material';
import { colors } from '../lib/styles';
const CustomSelect = (props) => {
  const { id, name, label, value, onChange, children, ...other } = props;
  return (
    <FormControl fullWidth>
      <InputLabel id={id} sx={{ color: colors.black }}>{label}</InputLabel>
      <MuiSelect
        {...other}
        labelId={id}
        name={name}
        label={label}
        value={value || ''}
        onChange={onChange}
        inputProps={{
          style: { color: colors.black }
        }}
      >
        {children}
      </MuiSelect>
    </FormControl>
  )
};

export default CustomSelect;